@if (agendaItem.supplementaryData?.itemDescription) {
    <div [froalaView]="agendaItem.supplementaryData?.itemDescription"></div>
}

@if (agendaItem.componentSelector) {
    <div class="alert alert-secondary my-3">
        <ng-container #container></ng-container>
    </div>
}

@for (note of agendaNotes; track note) {
    <adapt-display-meeting-note [note]="note"
                                [edit]="canEditMeetingItem$ | async"></adapt-display-meeting-note>
}
@for (link of agendaActionLinks; track link) {
    <adapt-display-action-link [showDeleteLink]="canEditMeetingItem$ | async"
                               [link]="link"></adapt-display-action-link>
}
@for (link of agendaObjectiveLinks; track link) {
    <adapt-display-meeting-objective-link [showDeleteLink]="canEditMeetingItem$ | async"
                                          [link]="link"></adapt-display-meeting-objective-link>
}
@if (canEditMeetingItem$ | async) {
    <div class="d-flex pt-1 align-items-center justify-content-end"
         data-tour="agenda-action-items">
        @if (canEditAgendaItem) {
            <adapt-agenda-item-action-menu class="me-auto"
                                           data-tour="edit-agenda-item-menu"
                                           [agendaItem]="agendaItem"
                                           [hideAddActions]="true"
                                           [hideEditAgendaItem]="false"></adapt-agenda-item-action-menu>
        }
        @if (!agendaItem.extensions.isFacilitationNotes && !agendaItem.extensions.isPreWork) {
            <button class="btn btn-primary btn-pill btn-minute"
                    data-tour="add-agenda-decision"
                    data-test="add-agenda-decision"
                    adaptTooltip="Add decision"
                    (click)="addDecision()">
                <i [ngClass]="MeetingNoteIconClass[MeetingNoteType.Decision]"></i>
            </button>
            <button class="btn btn-primary btn-pill btn-minute mx-1"
                    data-tour="add-agenda-minute"
                    data-test="add-agenda-minute"
                    adaptTooltip="Add minute"
                    (click)="addMinute()">
                <i [ngClass]="MeetingNoteIconClass[MeetingNoteType.Minute]"></i>
            </button>
            @if (hasEditableBoard) {
                <button class="btn btn-primary btn-pill btn-minute"
                        data-tour="add-agenda-work-item"
                        data-test="add-agenda-work-item"
                        adaptTooltip="Add action"
                        (click)="addMeetingItem()">
                    <i [ngClass]="MeetingItemIconClass"></i>
                </button>
            }
        }
    </div>
}
